import { render, staticRenderFns } from "./CatCarVersion.vue?vue&type=template&id=6c234ba4&"
import script from "./CatCarVersion.vue?vue&type=script&lang=js&"
export * from "./CatCarVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports